module.exports = __webpack_public_path__ + "img/content-1.9828cdb6.png";